// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"cb2c8c68","389":"89e43368","455":"29408817","505":"2dafb8e0","524":"0408ecd9","527":"d76d2c42","612":"c085a6c5","638":"ad33257e","646":"af6e72b8","850":"9cbe9e94"}[chunkId] + ".chunk.js";
};